var map = {
	"./2023/autumn/poster/battle_report2.png": "3a93",
	"./2023/summer/poster/battle_report2.png": "59ac",
	"./2024/autumn/poster/battle_report2.png": "f84e",
	"./2024/summer/poster/battle_report2.png": "4a89",
	"./2024/winter/poster/battle_report2.png": "d0a6",
	"./2025/spring/poster/battle_report2.png": "1c65",
	"./2025/summer/poster/battle_report2.png": "4bcf",
	"./2025/winter/poster/battle_report2.png": "bbea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d3ca";